import clsMerge from "../util/clsMerge";
import AlertBox, {AlertType} from "./AlertBox";

export type ServerErrorAlertProps = {
	errors: string[];
};

const ErrorsAlertBox: React.FC<ServerErrorAlertProps> = ({errors}) => {
	return (
		<AlertBox
			type={AlertType.ERROR}
			className={clsMerge("hidden", errors?.length > 0 && "my-2 block w-full")}
		>
			{errors.length > 1 ? (
				<ul>
					{errors.map((error) => (
						<li key={error}>{error}</li>
					))}
				</ul>
			) : (
				errors[0]
			)}
		</AlertBox>
	);
};

export default ErrorsAlertBox;
